module.exports = __webpack_public_path__ + "static/carissa-a064e32e3f5d3f440fe3c88bc26bcb4c.jpg";